
import Settings from './reducers';

export { receivedNewsSettings } from './actions';
export {
  getNewsSettings,
  getNewsOverviewLink,
  getNewsOverviewLinkLabel,
  getNewsReadMoreLabel,
  getNewsShareLabel,
  getNewsLoadMoreLabel,
  getLatestArticlesLabel,
} from './selectors';

export default Settings;
